import React from "react";
import { connect } from "react-redux";

import { validarPass, aceptoContrato } from "./services.act.js";
import { authentication } from "../app-database";
import { callService, goTo } from "../tools";
var timer;

const mapState = (state) => {
	return {
		cveCliente: state.login.cveCliente,
		correo: state.login.correo,
		secreto: state.login.secreto,
		intento: state.login.intento,
		pUno: state.login.pUno,
		pUnoText: state.login.pUnoText,
		pDos: state.login.pDos,
		pDosText: state.login.pDosText,
		hashOne: state.registroAF.hashOne,
		hashTwo: state.registroAF.hashTwo,
		accesoFamiliar: state.login.accesoFamiliar,
		uid: state.login.uid,
		email: state.login.correo,
		pass: state.login.contrasena,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		pasoAnterior: () => {
			dispatch({ "type": "LOGIN_PASO_ANTERIOR" });
			dispatch({ "type": "STATE_PATH_PUBLIC_NO_SOY_YO" });
		},
		setPass: (pass) => {
			dispatch({ "type": "LOGIN_SET_CONTRASENA", "contrasena": pass });
		},
		setCorreo: (correo) => {
			dispatch({ "type": "LOGIN_SET_CORREO", "correo": correo });
		},
		setSecreto: (secreto) => {
			dispatch({ "type": "LOGIN_SET_SECRETO", "secreto": secreto });
		},
		incrementaIntento: () => {
			dispatch({ "type": "LOGIN_INCREMENTA_INTENTO" });
		},
		resetPaso: () => {
			dispatch({ "type": "LOGIN_RESET_PASO" });
		},
		resetIntento: () => {
			dispatch({ "type": "LOGIN_RESET_INTENTO" });
		},
		pasoSiguiente: () => {
			dispatch({ "type": "LOGIN_PASO_SIGUIENTE" });
		},
		resetAccesoFamiliar: () => {
			dispatch({ "type": "LOGIN_SET_ACCESO_FAMILIAR", "accesoFamiliar": false });
		},
		aviso: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "IMPORTANTE", "mensaje": sMensaje });
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje": sMensaje });
		},
		alertaAccion: (sMensaje, fnAccion) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": "ERROR", "mensaje": sMensaje, "accion": fnAccion });
		},
		setPaso: (paso) => {
			dispatch({ "type": "LOGIN_SET_PASO", "paso": paso });
		},
		setClaveCliente: (uid) => {
			dispatch({ "type": "LOGIN_SET_UID", "uid": uid });
		},
		addEvento: (evento) => {
			dispatch({ "type": "LOGIN_SET_EVENT", "evento": evento });
		},
		eventoCorrectos: (dispositivo) => {
			dispatch({ "type": "EVENT_LOGIN_BIENVENIDO_CORRECTOS", "flujo": "login", "dispositivo": dispositivo });
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

class IngresaContrasena extends React.Component {
	state = {
		inputType: "password",
		inputClass: "input-wrap mt-30",
		inputActive: "",
		error: false,
		errorMsj: "",
		pass: "",
		bloqueado: false,
		classBtn: "orange-rectangle disabled",
	}

	changeInputType = () => {
		let type = this.state.inputType;
		this.setState({ inputType: type === "password" ? "text" : "password" });
		this.setState({ inputClass: type === "password" ? "input-wrap visible-input mt-50" : "input-wrap ver-input mt-50" });
	}

	altaAccesoFamiliar = () => {
		let $this = this;
		let llamaServicio = new callService({
			service: "accesoFamiliar.loginInvitacion",
			secure: true,
			data: {
				hashOne: this.props.hashOne,
				hashTwo: this.props.hashTwo,
				email: this.props.accesoFamiliar
			}
		}).execute().then((respuesta) => {
			console.log("Respuesta", respuesta);
			$this.props.resetAccesoFamiliar();
			goTo("home");
			
		}).catch((error) => {
			console.log("Error", error);
			$this.props.loader(false);
			$this.props.alertaAccion(error.message.mensaje, () => {
				goTo("home");
				
			});
		});
	}

	validarPass = () => {
		localStorage.removeItem("planesCliente");
		localStorage.removeItem("planesGNP");
		localStorage.removeItem("esCliente");
		localStorage.removeItem("clienteUnico");
		localStorage.removeItem("inactividad");
		let $this = this;
		$this.props.loader(true);

		this.setState({ bloqueado: true });
		let pass = this.state.pass;
		
		this.setState({ classBtn: "orange-rectangle" });
		if (!pass) {
			$this.props.loader(false);
			this.setState({ error: true });
			this.setState({ errorMsj: "Campo requerido." });
			this.props.addEvento("Bienvenido-CampoRequerido");
			this.props.tagManager({ "type": "EVENT_LOGIN_BIENVENIDO-VACIOS", "dispositivo": this.props.dispositivo });
			this.setState({ bloqueado: false });
			this.setState({ classBtn: "orange-rectangle disabled" });
		}
		this.props.setPass(pass);
		localStorage.setItem("cveCliente", this.props.cveCliente);
		validarPass(this.props.cveCliente, this.props.correo, pass).then((response) => response.json()).then((responseJson) => {
			
			if (responseJson.hasOwnProperty("jwt")) {
				authentication.signOut().then(function () {
					console.log("Signed Out");
					authentication.signInWithCustomToken(responseJson.jwt).then(function (result) {
						
						$this.props.eventoCorrectos($this.props.dispositivo);
						localStorage.setItem("refreshToken", responseJson.refreshtoken);
						
						if ($this.props.accesoFamiliar != false) {
							$this.altaAccesoFamiliar();
						} else {
							goTo("home");
						}
						
					}).catch(function (error) {
						console.log("signInWithCustomToken", error);
						$this.props.loader(false);
					});
				}, function (error) {
					console.error("Sign Out Error", error);
				});
			} else if (responseJson.hasOwnProperty("sesion")) {
				$this.props.loader(false);
				$this.setState({ bloqueado: false });
				this.props.tagManager({ "type": "EVENT_LOGIN_SESION-ACTIVA", "dispositivo": this.props.dispositivo });
				this.props.aviso("Ya cuentas con una sesión abierta, finaliza tu sesión activa para poder ingresar nuevamente.");
			} else if (responseJson.hasOwnProperty("errormedios")) {
				$this.props.loader(false);
				$this.setState({ bloqueado: false });
				this.props.alerta("Servicio no disponible, favor de intentarlo más tarde.");
			} else if (responseJson.hasOwnProperty("preguntas")) {
				$this.props.loader(false);

				if (!responseJson.preguntas) {
					$("#modal-primer-error").modal("toggle");
					$this.refs.inputContrasena.value = "";
					$this.setState({ pass: "" });
					$this.props.tagManager({ "type": "EVENT_LOGIN_BIENVENIDO-INCORRECTOS", "dispositivo": $this.props.dispositivo });
				} else {
					//this.props.resetIntento();
					$("#modal-bloqueado").modal("toggle");
				}
			} else if (responseJson.hasOwnProperty("estatusCliente") && responseJson.estatusCliente === "Inactivo") {
				$this.props.loader(false);
				$("#modal-user-bloqueado").modal("toggle");
			} else if (responseJson.hasOwnProperty("estatusCliente") && responseJson.estatusCliente === "InactivoAnio") {
				$this.props.loader(false);
				$("#modal-inactividad").modal("toggle");
			} else if (responseJson.hasOwnProperty("estatusCliente") && responseJson.estatusCliente === "Blacklist") {
				$this.props.loader(false);
				$("#modal-blacklist").modal("toggle");
			} else if (responseJson.hasOwnProperty("estatusCliente") && responseJson.estatusCliente === "Incompleto") {
				$this.props.loader(false);
				$("#modal-user-incompleto").modal("toggle");
			} else if (responseJson.hasOwnProperty("estatusCliente") && responseJson.estatusCliente === "Contratos") {
				$this.props.loader(false);
				$this.props.setClaveCliente(responseJson.cveCliente);
				$("#modal-contrato").modal("toggle");
			} else {
				$this.props.loader(false);
				$this.props.alerta("Hubo un error al Loguearse. Favor de intentar más tarde.");
			}
		}).catch((validarPassError) => {
			console.log(validarPassError);
			$this.props.loader(false);
			$this.props.alerta("Hubo un error al Loguearse. Favor de intentar más tarde.");
		});
	}

	handleBlur = (event) => {
		let pass = event.target.value;
		//this.setState({pass: pass});
		this.setState({ inputActive: pass ? "input-active" : "" });
		if (pass.length > 1) {
			this.setState({ classBtn: "orange-rectangle" });
		}
		else {
			this.setState({ classBtn: "orange-rectangle disabled" });
		}
	}

	handleFocus = (event) => {
		this.setState({ inputActive: "input-active" });
		this.setState({ errorMsj: "" });
		if (this.state.error) {
			this.setState({ pass: "" });
			event.target.value = "";
		}
		this.setState({ error: false });
	}

	enmascara = () => {

		var x;
		var charOrig, charMask;
		var lengthCad = $("#pass-login").val().length;
		var hide = "";
		var show = "";
		for (x = 0; x < lengthCad - 1; x++) {
			charMask = $("#pass-login").val().charAt(x);
			//charOrig = $("#pass-txt").val().charAt(x);
			charOrig = this.state.pass.charAt(x);
			if (charMask != unescape("%u25CF")) {
				hide += charMask;
				show += unescape("%u25CF");
			} else {
				hide += charOrig;
				if (charOrig != "") {
					show += unescape("%u25CF");
				}
			}
		}
		if ($("#pass-login").val().charAt(x) !== unescape("%u25CF")) {
			hide += $("#pass-login").val().charAt(x);
			show += $("#pass-login").val().charAt(x);
		}
		else {
			//hide += $("#pass-txt").val().charAt(x);
			hide += this.state.pass.charAt(x);
			show += $("#pass-login").val().charAt(x);
		}
		this.setState({ pass: hide });
		$("#pass-login").val(show);
		//$("#pass-txt").val(hide);
		clearTimeout(timer);
		timer = setTimeout(function () {
			let temp = "";
			for (x = 0; x < lengthCad; x++) {
				temp += unescape("%u25CF");
			}
			$("#pass-login").val(temp);
		}, 1000);
	}

	_handleKeyPress = (event) => {
		this.setState({ error: false });
		this.setState({ errorMsj: "" });
		if (event.key === "Enter") {
			this.setState({ bloqueado: true });
			if (!this.state.bloqueado) {
				console.log("Entro al enter 2");
				let pass = event.target.value;
				if (!pass) {
					this.setState({ error: true });
					this.setState({ errorMsj: "Campo requerido." });
					this.setState({ bloqueado: false });
				}
				this.validarPass();
			}
		} else {
			this.enmascara();
		}
	}

	siguientePregunta = () => {
		$("#modal-primer-error").modal("toggle");
		this.setState({ pass: "" });
		this.refs.inputContrasena.value = "";
		this.setState({ bloqueado: false });
		this.props.incrementaIntento();
	}

	regresar = () => {
		this.props.tagManager({ "type": "EVENT_LOGIN_BIENVENIDO_NO-SOY-YO", "dispositivo": this.props.dispositivo });
		this.props.setSecreto("");
		this.setState({ pass: "" });
		this.refs.inputContrasena.value = "";
		this.setState({ bloqueado: false });
		this.props.pasoAnterior();
	}
	
	goToPreguntas = () => {
		
		this.props.tagManager({ "type": "EVENT_LOGIN_UNO_CUENTABLOQUEADA-ACEPTAR", "dispositivo": this.props.dispositivo });
		localStorage.setItem("inactividad", true);
		$("#modal-bloqueado").modal("toggle");
		this.props.pasoSiguiente();
	}

	goToLogin = () => {
		$("#modal-user-bloqueado").modal("toggle");
		this.props.resetPaso();
	}

	goToLogin2 = () => {
		$("#modal-blacklist").modal("toggle");
		this.props.resetPaso();
	}

	goToPreguntasInactividad = () => {
		localStorage.setItem("inactividad", true);
		// GOOGLE TAG MANAGER //
		this.props.tagManager({ "type": "EVENT_LOGIN_UNO_CUENTABLOQUEADA-ACEPTAR", "dispositivo": this.props.dispositivo });

		$("#modal-inactividad").modal("toggle");
		this.props.pasoSiguiente();
	}

	goToOlvide = () => {
		$("#modal-user-incompleto").modal("toggle");
		this.props.resetPaso();

	}

	goToOlvidePass = () => {
		this.props.tagManager({ "type": "EVENT_LOGIN_BIENVENIDO-OLVIDE", "dispositivo": this.props.dispositivo });
		goTo("olvide");
	}

	aceptaContrato = () => {
		let $this = this;
		$("#modal-contrato").modal("toggle");
		$this.props.loader(true);
		
		aceptoContrato(this.props.uid, this.props.email, this.props.pass).then((response) => response.json()).then((responseJson) => {
			if (responseJson.hasOwnProperty("jwt")) {
				authentication.signOut().then(function () {
					console.log("Signed Out");
					authentication.signInWithCustomToken(responseJson.jwt).then(function (result) {
						
						localStorage.setItem("refreshToken", responseJson.refreshtoken);

						goTo("home");

					}).catch(function (error) {
						console.log("signInWithCustomToken", error);
						$this.props.loader(false);
					});
				}, function (error) {
					console.error("Sign Out Error", error);
				});
			} else {
				this.props.alerta("Hubo un error al Loguearse. Favor de intentar más tarde.");
			}
		});
	}

	cancelaContrato = () => {
		$("#modal-contrato").modal("toggle");
		this.props.resetPaso();
		goTo("login");
	}

	componentDidMount = () => {
		var passw = document.getElementById("pass-login");
		passw.focus();

		passw.onpaste = function (e) {
			try { e.preventDefault(); } catch (o) { }
		};
	}

	ir = (sRuta) => {
		goTo(sRuta);
	}

	render() {
		return <div className="login-form">
			<div className="login-form">
				<h3 className="orange-text">Bienvenido</h3>
				<h3>{this.props.secreto}</h3>
				<div className={this.state.inputClass}>
					<label>Contraseña</label>
					<span className="input-active">
						<input id="pass-login" maxLength="24" ref="inputContrasena" name="contrasenia" type="text" onBlur={this.handleBlur} 
							onFocus={this.handleFocus} onKeyUp={this._handleKeyPress} />
					</span>
					{this.state.error &&
						<div className="error-wrap">
							<div className="msj-error">
								{this.state.errorMsj}
							</div>
						</div>
					}
				</div>
				<div className="row btn-bottom mt-30">
					<div className="col-md-6 col-sm-6 col-xs-12" style={{ "marginBottom": 10 }}>
						<button name="nosoyyo" onClick={this.regresar} className="orange-rectangle disabled" style={{ "width": "138px" }}>No soy yo</button>
					</div>
					<div className="col-md-6 col-sm-6 col-xs-12">
						<button name="continuar" onClick={this.validarPass} disabled={this.state.bloqueado} className={this.state.classBtn} 
							style={{ "width": "138px" }}>Entrar</button>
					</div>
				</div>
			</div>
			<div className="text-center clearfix mt-38" style={{ "marginBottom": 20 }}>
				<a className="azul-italic" onClick={this.goToOlvidePass}>Olvidé mi contraseña</a>
			</div>
			<div className="modal fade" id="modal-primer-error" tabIndex="-1" role="dialog" aria-labelledby="modal-primer-errorLabel" 
				data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="">
							<h4 className="" id="modal-primer-errorLabel">Contraseña incorrecta</h4>
						</div>
						<div className="text-center">
							<p>Vuelve a ingresar tu contraseña.</p>
							<p>Por tu seguridad se bloqueará después de tres intentos fallidos.</p>
						</div>
						<div className="">
							<button type="button" className="btn orange-btn" onClick={this.siguientePregunta}>Aceptar</button>
						</div>
					</div>
				</div>
			</div>
			<div className="modal modal-msj fade" id="modal-bloqueado" tabIndex="-1" role="dialog" aria-labelledby="modal-bloqueadoLabel" 
				data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div>
							<h5 className="text-center" id="modal-bloqueadoLabel">Cuenta bloqueada</h5>
						</div>
						<div className="txt-black">
							<p>Por su seguridad conteste las preguntas secretas para continuar.
								Si lo prefieres puedes llamarnos al 55 5227 9000, en la opción 7 de lunes a viernes
								de 8:00 a 20:00 horas y sábados de 8:00 a 14:00 horas donde con gusto te atenderemos.</p>
						</div>
						<div className="text-center aceptar-cancelar-btn mt-20">
							<button type="button" className="btn orange-btn" onClick={this.goToPreguntas}>Aceptar</button>
						</div>
					</div>
				</div>
			</div>
			<div className="modal modal-msj fade" id="modal-user-bloqueado" tabIndex="-1" role="dialog" aria-labelledby="modal-user-bloqueadoLabel" 
				data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div>
							<h5 className="text-center" id="modal-user-bloqueadoLabel">Cuenta bloqueada</h5>
						</div>
						<div className="txt-black">
							<p>Por su seguridad conteste las preguntas secretas para continuar.
								Si lo prefieres puedes llamarnos al 55 5227 9000, en la opción 7 de lunes a viernes
								de 8:00 a 20:00 horas y sábados de 8:00 a 14:00 horas donde con gusto te atenderemos.</p>
						</div>
						<div className="text-center aceptar-cancelar-btn mt-20">
							<button type="button" className="btn orange-btn" onClick={this.goToPreguntas}>Aceptar</button>
						</div>
					</div>
				</div>
			</div>
			<div className="modal modal-msj fade" id="modal-blacklist" tabIndex="-1" role="dialog" aria-labelledby="modal-blacklistLabel" 
				data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div>
							<h5 className="text-center" id="modal-blacklistLabel">Su cuenta está en mantenimiento</h5>
						</div>
						<div className="txt-black">
							Agradecemos su comprensión, estamos trabajando para mejorar su experiencia. <br />
							Si requiere de algún tramite, por favor comunicarse a la Línea GNP. <br />
						</div>
						<div className="text-center aceptar-cancelar-btn mt-20">
							<button type="submit" className="orange-btn" style={{ "margin": "25px auto 0px auto", "display": "block" }} 
							onClick={this.goToLogin2}>Aceptar</button>
						</div>
					</div>
				</div>
			</div>
			<div className="modal modal-msj fade" id="modal-inactividad" tabIndex="-1" role="dialog" aria-labelledby="modal-inactividadLabel" 
				data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div>
							<h5 className="text-center" id="modal-inactividadLabel">Inactividad</h5>
						</div>
						<div className="txt-black">
							Tu cuenta ha sido bloqueada temporalmente debido a varios intentos de inicio de sesión incorrectos. 
							Solicita tu verificación por SMS y recibe un código de verificación (OTP) para cambiar tu contraseña.
						</div>
						<div className="text-center aceptar-cancelar-btn mt-20">
							<button type="submit" className="orange-btn" style={{ "margin": "25px auto 0px auto", "display": "block" }} 
								onClick={this.goToPreguntasInactividad}>Preguntas secretas</button>
						</div>
					</div>
				</div>
			</div>
			<div className="modal modal-msj fade" id="modal-contrato" tabIndex="-1" role="dialog" aria-labelledby="modal-contratoLabel" 
				data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div>
							<h5 className="text-center" id="modal-contratoLabel">Aviso</h5>
						</div>
						<div className="txt-black">
							Estimado cliente, el contrato de Uso de Medios Electrónicos ha sido modificado, lo invitamos a consultarlo en este portal
						</div>
						<div className="text-center aceptar-cancelar-btn mt-20">
							<a onClick={this.cancelaContrato}>Cancelar</a>
							<a className="orange-btn" onClick={this.aceptaContrato}>Aceptar</a>
						</div>
					</div>
				</div>
			</div>
			<div className="modal modal-msj fade" id="modal-user-incompleto" tabIndex="-1" role="dialog" aria-labelledby="modal-user-incompletoLabel" 
				data-backdrop="static" data-keyboard="false">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div>
							<h5 className="text-center" id="modal-user-incompletoLabel">Importante</h5>
						</div>
						<div className="txt-black">
							Se ha identificado que el proceso de registro no se completó correctamente,
							es necesario entrar a "Olvide mi contraseña" para que recibas un correo electrónico a tú cuenta para concluir el mismo.
						</div>
						<div className="text-center aceptar-cancelar-btn mt-20">
							<a className="orange-btn" onClick={this.goToOlvide}>Aceptar</a>
						</div>
					</div>
				</div>
			</div>
		</div>;
	}
}

export default connect(mapState, mapDispatch)(IngresaContrasena);



// WEBPACK FOOTER //
// ./src/gnp-login/ingresaContrasena.cmpt.js